import BgImage from "public/ransomwareProtection/techhStackBg.svg";
import Cisco from "public/cyberSecTechStack/cisco.png";
import Fortinet from "public/cyberSecTechStack/fortinet.png";
import PaloAlto from "public/cyberSecTechStack/paloalto.png";
import Sophos from "public/cyberSecTechStack/sophos.png";
import Crowdstrike from "public/cyberSecTechStack/crowdStrike.png";
import Radware from "public/cyberSecTechStack/radware.png";
import Eset from "public/cyberSecTechStack/eset.png";
import SentinelOne from "public/cyberSecTechStack/sentinelone-logo.jpg";

export const OUR_PARTNERS = [
  { name: "Cisco", logo: Cisco },
  { name: "PaloAlto", logo: PaloAlto },
  { name: "Fortinet", logo: Fortinet },
  { name: "Sophos", logo: Sophos },
  { name: "Crowdstrike", logo: Crowdstrike },
  { name: "Radware", logo: Radware },
  { name: "Eset", logo: Eset },
  { name: "SentinelOne", logo: SentinelOne },
];

export const TECH_STACK_CONSTANTS = {
  title: "Powered by Trusted Names in Cybersecurity",
  subTitle:
    "OneMind’s layered defense is strengthened through strategic integrations with:",
  concText:
    "Together, we bring enterprise-grade protection to organizations of all sizes — no silos, no gaps. ",
  bgImage: BgImage,
};
